import { defineComponent as i, computed as o, openBlock as s, createElementBlock as l, createElementVNode as t, toDisplayString as h, createCommentVNode as n, normalizeStyle as v, createStaticVNode as f } from "vue";
const m = ["viewBox"], p = /* @__PURE__ */ t("mask", { id: "3823000d-3137-46ed-b6df-db13d7c729d8" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), _ = { mask: "url(#3823000d-3137-46ed-b6df-db13d7c729d8)" }, g = { key: 0 }, k = /* @__PURE__ */ f('<path fill="#496e2d" d="M0 0h512v512H0z"></path><g fill="#eee"><path d="M144.7 306c0 18.5 15 33.5 33.4 33.5h100.2a27.8 27.8 0 0 0 27.8 27.8h33.4a27.8 27.8 0 0 0 27.8-27.8V306zm225.4-161.3v78c0 12.2-10 22.2-22.3 22.2v33.4c30.7 0 55.7-25 55.7-55.7v-77.9H370zm-239.3 78c0 12.2-10 22.2-22.3 22.2v33.4c30.7 0 55.7-25 55.7-55.7v-77.9h-33.4z"></path><path d="M320 144.7h33.4v78H320zm-50 44.5a5.6 5.6 0 0 1-11.2 0v-44.5h-33.4v44.5a5.6 5.6 0 0 1-11.1 0v-44.5h-33.4v44.5a39 39 0 0 0 39 39 38.7 38.7 0 0 0 22.2-7 38.7 38.7 0 0 0 22.2 7c1.7 0 3.4-.1 5-.3a22.3 22.3 0 0 1-21.6 17v33.4c30.6 0 55.6-25 55.6-55.7v-77.9H270z"></path><path d="M180.9 244.9h50v33.4h-50z"></path></g>', 2), u = { fill: "none" }, z = ["r"], N = /* @__PURE__ */ i({
  __name: "sa",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(d) {
    const e = d, a = o(() => 512 + 2 * e.strokeWidth), c = o(() => -e.strokeWidth), r = o(() => 256 + e.strokeWidth / 2);
    return (x, w) => (s(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${c.value} ${c.value} ${a.value} ${a.value}`
    }, [
      p,
      t("g", _, [
        e.flagName ? (s(), l("title", g, h(e.flagName), 1)) : n("", !0),
        k
      ]),
      t("g", u, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: r.value,
          fill: "none",
          style: v({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, z)
      ])
    ], 8, m));
  }
});
export {
  N as default
};
//# sourceMappingURL=sa-76af8f6e.js.map
